import { addDaysToDate, ceilToHalfHour } from "utils/dateHelpers";

export const title = "Remit";
export const remitDataCountThreshold = 5000;
export const defaultEndDate = ceilToHalfHour(new Date());
export const defaultStartDate = addDaysToDate(defaultEndDate, -1);
